import { Loader, X } from 'lucide-react';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";

interface ModalProps {
  open?: boolean;
  disabled?: boolean;
  disableConfirm?: boolean;
  loading?: boolean;
  triggerLabel: string;
  triggerClassName?: string;
  confirmLabel?: string;
  title: string;
  subTitle?: string;
  children: React.ReactNode;
  onConfirm: () => void
}

export default function ConfirmModal(props: ModalProps) {
  const {
    children,
    disabled,
    loading,
    title,
    subTitle,
    triggerLabel,
    triggerClassName,
    confirmLabel,
    disableConfirm,
    onConfirm,
    open
  } = props;
  const buttonLabel = confirmLabel ?? 'Confirm';
  return (
    <Dialog open={open}>
      <DialogTrigger asChild>
        <Button className={triggerClassName ?? ''} disabled={disabled}>{triggerLabel}</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px] bg-white !rounded-none border border-solid border-t-4 border-t-primary p-4">
        <DialogHeader className="!text-center">
          <DialogTitle className="flex items-center justify-between">
            <span className='text-primary'>{title}</span>
            <DialogClose asChild>
              <Button variant="ghost" className='font-bold'>
                <X size={30} />
              </Button>
            </DialogClose>
          </DialogTitle>
          {subTitle && (
            <DialogDescription className="text-small">
              {subTitle}
            </DialogDescription>
          )}
        </DialogHeader>
        <div className="grid gap-4">
          {children}
        </div>
        <DialogFooter className="!flex-col !space-x-0 gap-2 mt-4">
          <Button
            type="submit"
            disabled={disabled || disableConfirm}
            className="w-full text-white"
            onClick={() => onConfirm()}
          >
            {loading ? (<Loader />) : buttonLabel }
          </Button>
          <DialogClose asChild>
            <Button variant="ghost" className="w-full text-secondary">Cancel</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
